import groq from "groq";

/** GROQ filter for FAQ item arrays: keep items visible for the request `$locale`. */
export const faqItemLocaleVisibilityFilter = groq`!($locale in coalesce(hiddenInLocales, []))`;
